import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../../contexts/AuthContext';
import Button from '../../shared/Button';
import styles from './Cta.module.css';

const Cta = ({ data }) => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();

  if (!data) return null;

  const handleCtaClick = () => {
    if (isAuthenticated) {
      navigate('/dashboard');
      return;
    }
    navigate('/login', { state: { from: { pathname: '/dashboard' } } });
  };

  return (
    <section className={styles.ctaSection}>
      <div className={styles.ctaContainer}>
        <h2 className={styles.ctaTitle}>{data.title}</h2>
        <p className={styles.ctaDescription}>{data.description}</p>
        <Button 
          variant="primary" 
          onClick={handleCtaClick}
          className={styles.ctaButton}
        >
          {data.buttonText}
        </Button>
      </div>
    </section>
  );
};

export default Cta;


